import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NumberUtilsService {
  constructor() {}

  toRupiah(value?: number, decimal: boolean = true, symbol: boolean = true): string {
    const validateValue = value ?? 0;
    const fractionDigits = decimal ? 2 : 0;

    const options: Intl.NumberFormatOptions = symbol
      ? { style: 'currency', currency: 'IDR', minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }
      : { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits };

    return new Intl.NumberFormat('id-ID', options).format(validateValue).replace(/\s/g, '');
  }

  convertTwoDigits(value: number): string {
    return parseFloat(String(value)).toFixed(2);
  }

  toThousandConvert(value: number | string): string {
    let result: string;

    if (typeof value === 'string') {
      const num = parseFloat(value);
      const fixed = this.convertTwoDigits(num);
      result = new Intl.NumberFormat('id-ID').format(Number(fixed));
    } else {
      const fixed = this.convertTwoDigits(value);
      result = new Intl.NumberFormat('id-ID').format(Number(fixed));
    }

    return result;
  }

  toStringWithUnitType(input: string): string {
    const [numberPart, unitPart] = input.split(' ');
    const number = parseInt(numberPart);
    const formatted = new Intl.NumberFormat('id-ID', {
      maximumSignificantDigits: 3,
    }).format(number);
    return `${formatted} ${unitPart}`;
  }

  toNumberFormat(data: number): string {
    const floored = Math.floor(data * 1000) / 1000;
    return new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    }).format(floored);
  }

  stringNumberToPayload(value: string | number): number {
    if (typeof value === 'number') return isNaN(value) ? 0 : Math.trunc(value);
    return !!value ? parseInt(value.replaceAll('.', '')) : 0;
  }

  convertStringToNumberWithComma(input: string): number {
    const normalized = input.replaceAll(',', '.');
    return parseFloat(normalized);
  }

  formatInternationalNumber(value: string | number) {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return isNaN(value) ? 0 : value;
    // Remove thousand separators (dot) and replace decimal separator (comma → dot)
    const normalizedValue = value.replace(/\./g, '').replace(',', '.');
    return Number(normalizedValue);
  }

  reverseFormatInternationalNumber(value: number, useFixedDecimal = false) {
    if (isNaN(value) || value === null) return '0';
    let formatted = value.toFixed(2).replace('.', ',');
    // remove ",00"
    if (!useFixedDecimal && formatted.endsWith(',00')) formatted = formatted.slice(0, -3);
    return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Parses Indonesian-formatted number from appNumberInputFormat: "600.000,5" → 600000.5
  // Returns null for empty/invalid — distinguishes "not filled" from zero.
  parseFormNumber(value: any): number | null {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number') return isNaN(value) ? null : value;
    const n = parseFloat(value.toString().replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  // Parses percentage string from appNumberInputFormat: "12,5" → 12.5
  // Returns null for empty/invalid — distinguishes "not filled" from zero.
  parseFormPercentage(value: any): number | null {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number') return isNaN(value) ? null : value;
    const n = parseFloat(value.toString().replace(',', '.'));
    return isNaN(n) ? null : n;
  }
}
